module.exports = __webpack_public_path__ + "img/dept-12.99d795d3.svg";